export interface DealerAppRoute {
	path: string
	url: (...args: string[]) => string
}

export const route = (path: string) => ({
	path,
	url: () => path,
})
